<template>
  <v-container fluid fill-height>
    <v-slide-y-transition mode="out-in">
      <v-layout row wrap>
        <v-flex d-flex xs12>
          <v-card style="">
            <v-card-text>
              <v-layout row wrap>
                <h3 style="text-align:left;margin-bottom: 10px">Shipping Instructions Overview</h3>
                <v-btn flat class="primary" style="margin-left:800px;margin-bottom: 10px" v-on:click="back()">Back</v-btn>
              </v-layout>
              <v-divider divider: true></v-divider>
              <p style="margin-top:20px;text-align: left"><v-btn v-on:click="sho1(); activate(1);" :class="[(active_el === 1 ) ? 'active_el' : 'default']" flat>1. Pending SI Tasks 7</v-btn> / <v-btn v-on:click="sho2(); activate(2); " :class="[(active_el === 2 ) ? 'active_el' : 'default']" flat>2. Approve Verify Copy 5</v-btn>/ <v-btn v-on:click="sho3(); activate(3); " :class="[(active_el === 3 ) ? 'active_el' : 'default']" flat>3. Submitted SI Logs 10</v-btn></p>
              <v-flex v-show="show1">
                <v-flex d-flex>
                        <v-data-table
                          :headers="headers1"
                          :items="desserts1"
                          class="elevation-1"
                        >
                          <template slot="items" slot-scope="props">
                            <td>{{ props.item.no}}</td>
                            <td class="text-xs-left">{{ props.item.bookingNumber }}</td>
                            <td class="text-xs-left">{{ props.item.fromportofloading}}</td>
                            <td class="text-xs-left">{{ props.item.fromportofdischargel}}</td>
                            <td class="text-xs-left">{{ props.item.vessel}}</td>
                            <td class="text-xs-left"><v-btn class="primary" v-on:click="submitsi()">Submit SI</v-btn></td>
                          </template>
                        </v-data-table>
                </v-flex>
              </v-flex>
              <v-flex v-show="show2">
                <v-flex d-flex>
                        <v-data-table
                          :headers="headers2"
                          :items="desserts2"
                          class="elevation-1"
                        >
                          <template slot="items" slot-scope="props">
                            <td>{{ props.item.no}}</td>
                            <td class="text-xs-left">{{ props.item.billoflanding }}</td>
                            <td class="text-xs-left"><a href="">View PDF</a></td>
                            <td class="text-xs-left">{{ props.item.fromportofloading}}</td>
                            <td class="text-xs-left">{{ props.item.fromportofdischargel}}</td>
                            <td class="text-xs-left">{{ props.item.vessel}}</td>
                            <td class="text-xs-left"><v-btn class="primary">Approve</v-btn><v-btn class="warning">Amend</v-btn></td>
                          </template>
                        </v-data-table>
                </v-flex>
              </v-flex>
              <v-flex v-show="show3">
                <v-flex d-flex>
                        <v-data-table
                          :headers="headers3"
                          :items="desserts3"
                          class="elevation-1"
                        >
                          <template slot="items" slot-scope="props">
                            <td>{{ props.item.no}}</td>
                             <td class="text-xs-left">{{ props.item.billoflanding }}</td>
                            <td class="text-xs-left"><a href="">View PDF</a></td>
                            <td class="text-xs-left">{{ props.item.fromportofloading}}</td>
                            <td class="text-xs-left">{{ props.item.fromportofdischargel}}</td>
                            <td class="text-xs-left">{{ props.item.vessel}}</td>
                            <td class="text-xs-left"><v-btn class="primary">SI Submitted</v-btn></td>
                          </template>
                        </v-data-table>
                </v-flex>
              </v-flex>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      active_el: 1,
      dropdown_list: [1, 2, 3, 4, 5],
      headers1: [
        {
          text: '#',
          align: 'left',
          value: 'no'
        },
        { text: 'Booking Number', value: 'bookingNumber' },
        { text: 'From (Port of Loading)', value: 'fromportofloading' },
        { text: 'From (Port of Dischargel)', value: 'fromportofdischargel' },
        { text: 'Vessel', value: 'vessel' },
        { text: 'Submit SI Details', value: 'submitsidetails' }
      ],
      desserts1: [
        {
          no: '1',
          bookingNumber: 'AME/FF/160900012',
          fromportofloading: 'Jeddah, SA',
          fromportofdischargel: 'Bejaia DZ',
          vessel: 'MAERSK Talkung'
        },
        {
          no: '2',
          bookingNumber: 'AME/FF/160900012',
          fromportofloading: 'Jeddah, SA',
          fromportofdischargel: 'Bejaia DZ',
          vessel: 'MAERSK Talkung'
        },
        {
          no: '3',
          bookingNumber: 'AME/FF/160900012',
          fromportofloading: 'Jeddah, SA',
          fromportofdischargel: 'Bejaia DZ',
          vessel: 'MAERSK Talkung'
        }
      ],
      headers2: [
        {
          text: '#',
          align: 'left',
          value: 'no'
        },
        { text: 'Bill of Landing', value: 'billoflanding' },
        { text: 'View PDF', value: 'viewpdf' },
        { text: 'From (Port of Loading)', value: 'fromportofloading' },
        { text: 'From (Port of Dischargel)', value: 'fromportofdischargel' },
        { text: 'Vessel', value: 'vessel' },
        { text: 'Submit SI Details', value: 'submitsidetails' }
      ],
      desserts2: [
        {
          no: '1',
          billoflanding: 'AME/FF/160900012',
          fromportofloading: 'Jeddah, SA',
          fromportofdischargel: 'Bejaia DZ',
          vessel: 'MAERSK Talkung'
        },
        {
          no: '2',
          billoflanding: 'AME/FF/160900012',
          fromportofloading: 'Jeddah, SA',
          fromportofdischargel: 'Bejaia DZ',
          vessel: 'MAERSK Talkung'
        },
        {
          no: '3',
          billoflanding: 'AME/FF/160900012',
          fromportofloading: 'Jeddah, SA',
          fromportofdischargel: 'Bejaia DZ',
          vessel: 'MAERSK Talkung'
        }
      ],
      headers3: [
        {
          text: '#',
          align: 'left',
          value: 'no'
        },
        { text: 'Bill of Landing', value: 'billoflanding' },
        { text: 'View PDF', value: 'viewpdf' },
        { text: 'From (Port of Loading)', value: 'fromportofloading' },
        { text: 'From (Port of Dischargel)', value: 'fromportofdischargel' },
        { text: 'Vessel', value: 'vessel' },
        { text: 'Submit SI Details', value: 'submitsidetails' }
      ],
      desserts3: [
        {
          no: '1',
          billoflanding: 'AME/FF/160900012',
          fromportofloading: 'Jeddah, SA',
          fromportofdischargel: 'Bejaia DZ',
          vessel: 'MAERSK Talkung'
        },
        {
          no: '2',
          billoflanding: 'AME/FF/160900012',
          fromportofloading: 'Jeddah, SA',
          fromportofdischargel: 'Bejaia DZ',
          vessel: 'MAERSK Talkung'
        },
        {
          no: '3',
          billoflanding: 'AME/FF/160900012',
          fromportofloading: 'Jeddah, SA',
          fromportofdischargel: 'Bejaia DZ',
          vessel: 'MAERSK Talkung'
        }
      ],
      show1: true,
      show2: false,
      show3: false
    }
  },
  mounted () {
    console.log('bulkbooking page')
  },
  methods: {
    sho1 () {
      this.show1 = true
      this.show2 = false
      this.show3 = false
    },
    sho2 () {
      this.show2 = true
      this.show1 = false
      this.show3 = false
    },
    sho3 () {
      this.show3 = true
      this.show2 = false
      this.show1 = false
    },
    back () {
      this.$router.push('/Dashboard')
    },
    submitsi () {
      this.$router.push('/Shippinginstructionsdocument')
    },
    activate (el) {
      this.active_el = el
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.active_el {
  color: #00C853
}

</style>



// WEBPACK FOOTER //
// src/components/Shippinginstructionsoverview.vue